import gql from 'graphql-tag';

const query = gql`
  query FavoriteMealDetails($mealId: Int!) {
    diabetes {
      userDiabetes {
        diabeticDietConfig {
          showCarbohydrateUnit
          showProteinFatUnit
          showAssimilableCarbohydrate
        }
      }
    }
    me {
      id
      diet {
        dietId: id
        availableDays {
          date
        }
      }
      favoriteMeal(mealId: $mealId) {
        id
        kcal
        macro {
          protein {
            grams
            kcal
            percentage
          }
          animalProtein {
            grams
            kcal
            percentage
          }
          fat {
            grams
            kcal
            percentage
          }
          carbohydrates {
            grams
            kcal
            percentage
          }
          dietaryFiberGrams
        }
        preparationTime {
          years
          months
          days
          hours
          minutes
          seconds
        }
        dishes {
          id
          name
          recipe
          ingredients {
            productAmountId
            productId
            name
            category {
              id
              isSeasoning
              isOptional
              name
            }
            measurements {
              measureId
              amount
              unit
              text
              isBaseUnit
            }
            kcal
            macro {
              protein {
                grams
              }
              fat {
                grams
              }
              carbohydrates {
                grams
              }
              dietaryFiberGrams
            }
            saleProductVariant {
              link
            }
            note {
              title
              content
            }
            hasReplacement
            original {
              productId
              name
              measurements {
                amount
                unit
                text
              }
            }
            replacements {
              productId
              name
              measurements {
                amount
                unit
                text
              }
            }
          }
          triangleOfPower {
            body
            mind
            libido
          }
        }
        preparationVideoUrl
        preparationImageUrl
        publicName
        name
        dietId
        mealType
        phase {
          identifier
          name
          colour
        }
        diabeticDetails {
          assimilableCarbohydrate
          carbohydrateUnit
          fatProteinUnit
        }
        mealCustomTag {
          label
          color
        }
        rating {
          availableLabels {
            name
          }
          averageRating {
            averageRating
            ratingsCount
          }
          userRating {
            rating
            labels {
              name
            }
          }
        }
      }
    }
  }
`;

export default query;
